export default __webpack_public_path__ + "static/media/dali.3737cf8d.jpg";